module.exports = __webpack_public_path__ + "static/media/main2_rwd.2583bdb2.png";